import React from "react";
import Icon from "components/AppIcon";

const EvidenceMeter = ({ evidence = 0, maxEvidence = 100 }) => {
  const pct = Math.min(100, Math.max(0, (evidence / maxEvidence) * 100));
  const level = pct >= 80 ? "critical" : pct >= 50 ? "high" : pct >= 25 ? "medium" : "low";
  const config = {
    critical: { color: "var(--color-error)", label: "CRITICAL", glow: "var(--glow-error)", icon: "AlertTriangle" },
    high: { color: "var(--color-warning)", label: "HIGH", glow: "var(--glow-amber)", icon: "AlertCircle" },
    medium: { color: "#f97316", label: "MEDIUM", glow: "none", icon: "Eye" },
    low: { color: "var(--color-success)", label: "LOW", glow: "var(--glow-success)", icon: "Shield" },
  };
  const cfg = config?.[level];

  return (
    <div className="rounded-xl p-4 md:p-5" style={{ background: "var(--color-card)", border: "1px solid var(--color-border)" }}>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Icon name="Eye" size={16} color={cfg?.color} />
          <span className="font-heading text-sm font-semibold text-foreground">Evidence Accumulation</span>
        </div>
        <div className="flex items-center gap-1.5 px-2 py-1 rounded" style={{ background: `${cfg?.color}18`, border: `1px solid ${cfg?.color}40` }}>
          <Icon name={cfg?.icon} size={12} color={cfg?.color} />
          <span className="font-caption text-xs font-medium" style={{ color: cfg?.color }}>{cfg?.label}</span>
        </div>
      </div>
      <div className="mb-2">
        <div className="flex justify-between mb-1">
          <span className="font-caption text-xs text-muted-foreground">Detection Risk</span>
          <span className="font-caption text-xs font-medium" style={{ color: cfg?.color }}>{evidence}/{maxEvidence}</span>
        </div>
        <div className="h-3 rounded-full overflow-hidden" style={{ background: "rgba(0,0,0,0.3)", border: "1px solid rgba(255,255,255,0.05)" }}>
          <div
            className="h-full rounded-full transition-all duration-500"
            style={{ width: `${pct}%`, background: cfg?.color, boxShadow: cfg?.glow }}
          />
        </div>
      </div>
      {pct >= 50 && (
        <div className="flex items-start gap-2 mt-3 p-2 rounded-lg" style={{ background: `${cfg?.color}10`, border: `1px solid ${cfg?.color}25` }}>
          <Icon name="AlertTriangle" size={13} color={cfg?.color} className="flex-shrink-0 mt-0.5" />
          <p className="font-caption text-xs" style={{ color: cfg?.color }}>
            {pct >= 80
              ? "Authorities are closing in. Avoid high-risk crimes immediately." :"Elevated detection risk. Consider lower-profile activities."}
          </p>
        </div>
      )}
    </div>
  );
};

export default EvidenceMeter;